
const colors = {
  snow: 'white',
  coal: '#2d2d2d',
  whiteSmoke: '#f7f7f8',
  lightGray: '#D3D3D3',
  transparentBlack: 'rgba(0,0,0,0.3)',
  transparent: 'rgba(0,0,0,0)',
  transparentWhite: 'rgba(255,255,255,0.1)',
  steel: '#CCCCCC',
  error: 'rgba(200, 0, 0, 0.8)',
  success: '#16a085',
  ricePaper: 'rgba(255,255,255, 0.75)',
  frost: '#D8D8D8',
  cloud: 'rgba(200,200,200, 0.35)',
  windowTint: 'rgba(0, 0, 0, 0.4)',
  panther: '#161616',
  charcoal: '#595959',
  bloodOrange: '#fb5f26',
  ember: 'rgba(164, 0, 48, 0.5)',
  fire: '#e73536',
  drawer: 'rgba(30, 30, 29, 0.95)',
  eggplant: '#251a34',
  border: '#483F53',
  banner: '#5F3E63',
  text: '#E0D7E5'
}

export default colors
